export const visit = (vm, at) => {
at({ "es": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Se produjo un problema de conexi\xF3n de red.", "message": "Comprueba tu conexi\xF3n e int\xE9ntalo de nuevo.", "button": "Int\xE9ntelo de nuevo" } } } } });
};